const QueryString = function (url) {
  const queryString = new Proxy(new URLSearchParams(url), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  return queryString
}

export default QueryString
